var _classCallCheck = require("/Users/halliefaust/Desktop/scope/website-revamp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var GoogleSpreadsheetFormulaError = function GoogleSpreadsheetFormulaError(errorInfo) {
  "use strict";

  _classCallCheck(this, GoogleSpreadsheetFormulaError);
  this.type = errorInfo.type;
  this.message = errorInfo.message;
};
module.exports = {
  GoogleSpreadsheetFormulaError: GoogleSpreadsheetFormulaError
};